import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class SSOTokenInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // add authorization header with jwt token if available
    if (request.url.endsWith('/password/reset/change')) {
      // dont intercept
      return next.handle(request);
    }
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (
      request.url.includes('routing/v1/routingprofiles') ||
      request.url.includes(environment.daUrl)
    ) {
      request = request.clone({
        setHeaders: {
          Authorization: `${currentUser?._jwtToken.token_type} ${currentUser?._jwtToken.access_token}`,
        },
      });
      return next.handle(request);
    }
    if (
      currentUser?.authToken &&
      request.url.includes(environment.pcmilerAppUrl)
    ) {
      const basicAuthHeader = `${currentUser?.userName}:${currentUser?.account}:${currentUser?.authToken}`;
      const encodedHeader = `Basic ${window.btoa(basicAuthHeader)}`;
      request = request.clone({
        setHeaders: {
          Authorization: encodedHeader,
        },
      });
      return next.handle(request);
    }
    let value = 'Bearer ';
    if (request.url.includes(environment.singleSearchbaseUrl)) {
      value = 'token=';
    }

    if (currentUser?.authToken) {
      request = request.clone({
        setHeaders: {
          Authorization: `${value}${currentUser.authToken}`,
        },
      });
    }

    if (currentUser?.authToken && request.url.includes(environment.pcmwsUrl)) {
      value = 'token=';
      request = request.clone({
        setHeaders: {
          Authorization: `${value}${currentUser.authToken}`,
        },
      });
    }

    return next.handle(request);
  }
}
